import { TestIdDomain } from 'constants/testIds';

const MERS_PREVIEW_DRAWER_SCOPE = 'mers-preview-drawer';
const FIELDS_TABLE_SCOPE = 'fields-table';

export const MersPreviewDrawerTestIds = {
  DRAWER: `${TestIdDomain.LOAN_ACTIONS}.${MERS_PREVIEW_DRAWER_SCOPE}`,
  CONTEXT: `${MERS_PREVIEW_DRAWER_SCOPE}.context-label`,
  VERDICT_BANNER: `${MERS_PREVIEW_DRAWER_SCOPE}.verdict-banner`,
  ERRORS: `${MERS_PREVIEW_DRAWER_SCOPE}.errors-list`,
  FIELDS_TABLE: `${MERS_PREVIEW_DRAWER_SCOPE}.${FIELDS_TABLE_SCOPE}`,
  FIELDS_TABLE_ROW: `${FIELDS_TABLE_SCOPE}.row`,
  PAYLOAD_ACCORDION: `${MERS_PREVIEW_DRAWER_SCOPE}.payload-accordion`,
  PAYLOAD: `${MERS_PREVIEW_DRAWER_SCOPE}.payload-label`,
  NO_PAYLOAD: `${MERS_PREVIEW_DRAWER_SCOPE}.no-payload-label`,
  COPY_PAYLOAD_BUTTON: `${MERS_PREVIEW_DRAWER_SCOPE}.copy-payload-button`,
};
